/**
 * An enumeration that defines WebSocket events.
 *
 * @readonly
 * @enum {string}
 */
export enum EWebSocketEvent {
  /**
   * The "connect" event.
   */
  Connect = 'connect',

  /**
   * The "ping" event.
   */
  Ping = 'ping',

  /**
   * The "pong" event.
   */
  Pong = 'pong',

  /**
   * The "connectToRoom" event.
   */
  ConnectToRoom = 'connectToRoom'
}

/**
 * An enumeration that defines WebSocket package types.
 *
 * @readonly
 * @enum {string}
 */
export enum EWebSocketPackageType {
  /**
   * The "paid-message" package data.
   */
  PaidMessage = 'paid-message',
  MessageReplied = 'message-replied',
  DeactivatedByRates = 'deactivated-by-rates',
  CompanyCurrencyUpdated = 'company-currency-updated',
  WorkerSignupFinished = 'worker-signup-finished',
}
